<template>
  <Transition
    leave="transition ease-in duration-200"
    leaveFrom="opacity-100"
    leaveTo="opacity-0"
    enter="transition ease-in duration-200"
    enterTo="opacitiy-100"
    enterFrom="opacity-0"
  >
    <div class="absolute z-50 mt-1 flex justify-center">
      <div class="z-49 absolute h-4 w-4 rotate-45 bg-red-500" />
      <div
        class="shadow-2xl z-50 mt-2 flex justify-center rounded bg-red-500 p-2 font-bold text-white"
      >
        {{ errorMessage }}
      </div>
    </div>
  </Transition>
</template>

<script>
export default {
  name: 'InputErrorPopup',
  props: {
    errorMessage: {
      type: String,
      default: 'This field is required.',
    },
  },
};
</script>
